import styled from "styled-components";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { useEffect, useMemo, useState } from "react";

import IdFilter from "./IdFilter";
import SearchFilter from "./SearchFilter";
import ChangeFilter from "./ChangeFilter";
import { tabToRoute, useCurrentTab } from "@/hooks/useCurrentTab";

const Row = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`;

function Search() {
    const { version } = useParams({ from: "/$version" });
    const navigate = useNavigate({ from: "/$version" });
    const applied = useSearch({
        from: "/$version",
        select: (state) => ({
            id: state.id,
            q: state.q,
            since: state.since,
        }),
    });
    const tab = useCurrentTab();

    const to = useMemo(() => tabToRoute(tab), [tab]);

    const [draftId, setDraftId] = useState(applied.id ?? "");
    const [draftQ, setDraftQ] = useState(applied.q ?? "");
    const [draftSince, setDraftSince] = useState(applied.since ?? "");

    useEffect(() => {
        setDraftId(applied.id ?? "");
        setDraftQ(applied.q ?? "");
        setDraftSince(applied.since ?? "");
    }, [applied.id, applied.q, applied.since]);

    const onSearch = () => {
        navigate({
            to,
            params: { version },
            search: (prev) => ({
                ...prev,
                id: draftId.trim().toLowerCase() || undefined,
                q: draftQ.trim() || undefined,
                since: draftSince || undefined,
                page: undefined,
            }),
        });
    };

    const onClear = () => {
        setDraftId("");
        setDraftQ("");
        setDraftSince("");
        navigate({
            to,
            params: { version },
            search: (prev) => ({
                ...prev,
                id: undefined,
                q: undefined,
                since: undefined,
                page: undefined,
            }),
        });
    };

    return (
        <fieldset>
            <legend>Search</legend>
            <IdFilter value={draftId} onChange={setDraftId} />
            <SearchFilter value={draftQ} onChange={setDraftQ} />
            <ChangeFilter value={draftSince} currentVersion={version} onChange={setDraftSince} />
            <Row>
                <button type="button" onClick={onSearch}>
                    Search
                </button>
                <button type="button" onClick={onClear}>
                    Clear
                </button>
            </Row>
        </fieldset>
    );
}

export default Search;
